import { userAuthorizedSelector } from "@/redux/authorization/authorization.selector";
import { useGetProfileQuery } from "@/redux/user/user.api";
import { useSelector } from "react-redux";

export const useUserProfile = (enabled = true) => {
  const { isAuthorized } = useSelector(userAuthorizedSelector);
  const query = useGetProfileQuery(undefined, {
    skip: !enabled || !isAuthorized
  });
  return query;
};
